import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "container mx-auto mt-4" }
const _hoisted_2 = { class: "border-t-2 border-gray-300 py-4 w-full" }
const _hoisted_3 = { class: "flex justify-between" }
const _hoisted_4 = { class: "text-lg" }
const _hoisted_5 = { class: "text-lg text-gray-600" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 17v4M12 21v-4M12 12V2M5 21H19a2 2 0 002-2V9a2\n        2 0 00-2-2h-2V5a2 2 0 00-2-2H9a2 2 0 00-2 2v2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
  })
], -1)
const _hoisted_8 = [
  _hoisted_7
]

import { Versions } from '@/service/client/versions-client';
import { version } from 'vue';

// eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'VersionsList',
  props: {
  versions: {
    type: Array as () => Versions,
  },
},
  setup(__props) {

const props = __props;



const downloadFile = (index:number) : void => {
  const values = props.versions?.values();
  if (!values) {
    return;
  }
  const foundValue = Array.from(values).filter((e, i) => index === i)[0];

  window.location.href = foundValue.link;
};

const formatDate = (date : Date) => date.toDateString();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.versions, (version, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "w-full"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, "conroo-" + _toDisplayString(version.name), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(formatDate(new Date(version.createdDate))), 1),
            _createElementVNode("button", {
              onClick: ($event: any) => (downloadFile(index)),
              class: "bg-blue-500 hover:bg-[#00295b] text-white font-bold py-2 px-4 rounded flex items-center"
            }, _hoisted_8, 8, _hoisted_6)
          ])
        ])
      ]))
    }), 128))
  ]))
}
}

})